import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { StatBadges } from './components/StatBadges';
import { TestimonialsIntro } from './components/TestimonialsIntro';
import { PainsSection } from './components/PainsSection';
import { SystemSection } from './components/SystemSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { EliteSection } from './components/EliteSection';
import { ComparisonTable } from './components/ComparisonTable';
import { TestimonialsFull } from './components/TestimonialsFull';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FooterCta } from './components/FooterCta';
import { PurchasePopup } from './components/PurchasePopup';
import { initPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StatBadges data-id="element-2" />
      <TestimonialsIntro data-id="element-3" />
      <PainsSection data-id="element-4" />
      <SystemSection data-id="element-5" />
      <TomosSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <EliteSection data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <TestimonialsFull data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FaqSection data-id="element-13" />
      <FooterCta data-id="element-14" />
      <PurchasePopup data-id="element-15" />
    </div>;
}